import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Checkbox } from '../../../../ps-aspect-design';
import { string, func, bool, object, array } from 'prop-types';
import apiClient from 'ps-components/lib/apiClient';
import cn from 'classnames';
import InPlaceIndicator from '../../../LoadingIndicator/InPlaceIndicator/InPlaceIndicator';

AddCollectionDropdown.propTypes = {
  className: string,
  render: bool,
  wrapperRef: object,
  createNewCollection: func,
  addReportsToCollections: func,
  reportsSelected: array,
  setShowAddCollectionDropdown: func,
  userSiteAdmin: bool,
  userGroupAdmin: bool
};

function AddCollectionDropdown(props) {
  const [checkedItems, setCheckedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collections, setCollections] = useState([]);
  const [addLoading, setAddLoading] = useState(false);

  useEffect(() => {
    if (props.render) {
      setLoading(true);

      apiClient
        .apiGet('api/report-library/collections/getCollections', {
          params: {
            onlyCustom: true
          }
        })
        .then(response => {
          const { success, collections } = response.data;
          if (success) {
            // only show group collections in dropdown for group admins
            if (props.userGroupAdmin && !props.userSiteAdmin) {
              const filteredCollections = collections.filter(c => c.org_group_id != null);
              setCollections(filteredCollections);
            } else {
              setCollections(collections);
            }
          }

          setLoading(false);
        });
    }
  }, [props.render]);

  if (!props.render) return null;

  function addReportsToCollections() {
    setAddLoading(true);

    props
      .addReportsToCollections({
        reportIds: props.reportsSelected.map(r => Number(r.id)),
        collectionIds: checkedItems
      })
      .then(response => {
        setAddLoading(false);
        setCheckedItems([]);

        if (response !== 409) {
          props.setShowAddCollectionDropdown(false);
          props.deselectAllReports();
        }
      });
  }

  function getCollectionList() {
    if (loading) {
      return <InPlaceIndicator />;
    }

    if (collections.length === 0) {
      return <div className="no-results">No custom collections found</div>;
    }

    const items = collections.map(col => {
      return (
        <div className="collection-item" key={`collection-item-${col.id}`}>
          <Checkbox
            value={checkedItems.includes(col.id)}
            onChange={(event, isChecked) => {
              if (isChecked && !checkedItems.includes(col.id)) {
                setCheckedItems(checkedItems.concat(col.id));
              } else if (!isChecked && checkedItems.includes(col.id)) {
                const foundIndex = checkedItems.findIndex(item => item === col.id);
                if (foundIndex > -1) {
                  const newItems = [...checkedItems];
                  newItems.splice(foundIndex, 1);
                  setCheckedItems(newItems);
                }
              }
            }}
          />
          <div className="collection-name">{col.name}</div>
        </div>
      );
    });

    return (
      <>
        <div className="add-collection__items">
          <div className="info">Select collections to add selected reports</div>
          <div className="items">{items}</div>
        </div>

        <div className="add-collection__buttons">
          <ButtonGroup>
            {addLoading ? (
              <InPlaceIndicator />
            ) : (
              <Button
                variant="primary"
                disabled={checkedItems.length === 0}
                onClick={addReportsToCollections}
                className="add-collection_button"
              >
                Add to Collections
              </Button>
            )}
          </ButtonGroup>
        </div>
      </>
    );
  }

  return (
    <div className={props.className} ref={props.wrapperRef}>
      <div className="add-collection__header">
        <div className="add-collection__title">Custom Popular Report Collections</div>
        <div
          className="add-collection__create-link"
          data-test-id="add-collection__create-link"
          onClick={props.createNewCollection}
        >
          Create a new collection
        </div>
      </div>

      <div className={cn('add-collection__list', { scroll: props.collections.length > 4 })}>{getCollectionList()}</div>
    </div>
  );
}

export default AddCollectionDropdown;
